export const zeroNaNs = (n: number) => (Number.isNaN(n) ? 0 : n);
